import React from 'react';
import Logo from './mybiz.png'

function UserNotOnboarded() {

    const Params = new URLSearchParams(window.location.search);
    const error = Params.get('error');

    return (
        <div className='h-100-center pd-3'>
            <div className='text-center'>
                <img src={Logo} alt='logo' style={{height:80}} />
                <h2 className='mt-4'>User not Onboarded</h2>
                <div className='text-small'>
                    Your are not onboarded to use this application. Please contact your company administrator.<br/>
                    ( {error} )
                </div>
            </div>
        </div>
    );
}

export default UserNotOnboarded;